module.exports = __webpack_public_path__ + "static/hero-wallpaper-2440619a7692b3f528afeeb4bf341f58.jpg";